<template>
  <v-dialog
    :model-value="dialog"
    fullscreen
    persistent
    :overlay="false"
    transition="dialog-transition"
  >
    <v-app-bar fixed class="bg">
      <v-row class="d-flex align-center justify-space-between">
        <v-col cols="6" md="6">
          <v-img
            class="ma-0 pa-0 text-start"
            width="200"
            src="@/assets/Kotler_and_levit_logo.png"
          />
        </v-col>
        <v-col cols="6" md="6">
          <div class="text-primary font-weight-bold me-4 text-end">
            {{
              new Date().toLocaleDateString("en-GB", {
                weekday: "long",
                day: "2-digit",
                month: "short",
                year: "numeric",
              })
            }}
          </div>
        </v-col>
      </v-row>
    </v-app-bar>
    <v-card class="position-relative">
      <!-- confetti canvas sits on top of the card -->
      <canvas ref="confettiCanvas" class="confetti-canvas" />

      <v-row
        align="center"
        justify="center"
        :style="{ height: '100vh' }"
        no-gutters
      >
        <v-col cols="12" class="text-center d-flex justify-center">
          <v-card
            color="transparent"
            elevation="0"
            :width="
              VuetifyObj.mdAndUp
                ? VuetifyObj.width * 0.6
                : VuetifyObj.width * 0.98
            "
          >
            <v-card-text>
              <v-icon
                class="mb-4"
                color="success"
                icon="mdi-check-all"
                size="112"
              />

              <h2 class="text-h5 mb-6">Registration Successful</h2>
              <div class="text-h6 mb-2">Directions to Attend Exam</div>
              <p class="mb-2">
                After your registration is approved, an email will be sent to
                your registered email ID with the exam access link.
              </p>
              <p class="mb-2">
                If you do not find it in your inbox, please check your spam/junk
                folder as well.
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    VuetifyObj: Object,
  },

  watch: {
    dialog(val) {
      if (val) {
        // ensure DOM updated then fire confetti
        this.$nextTick(() => {
          this.fireConfetti();
        });
      }
    },
  },

  methods: {
    async fireConfetti() {
      try {
        // guard for SSR (window undefined)
        if (typeof window === "undefined") return;

        // dynamic import — safe for SSR builds and avoids bundling issues
        const confettiModule = await import("canvas-confetti");
        const confettiFn = confettiModule.default || confettiModule;

        // create confetti instance bound to our canvas
        const canvas = this.$refs.confettiCanvas;
        if (!canvas) {
          // fallback: call global confetti which will create its own canvas
          confettiFn({
            particleCount: 120,
            spread: 70,
            origin: { y: 0.6 },
          });
          setTimeout(() => {
            confettiFn({
              particleCount: 80,
              spread: 100,
              origin: { y: 0.6 },
            });
          }, 300);
          return;
        }

        const myConfetti = confettiFn.create(canvas, {
          resize: true, // keep canvas sized to container
          useWorker: true, // offload to worker if available
        });

        // two bursts for nice effect
        myConfetti({
          particleCount: 140,
          spread: 70,
          origin: { y: 0.6 },
        });

        setTimeout(() => {
          myConfetti({
            particleCount: 90,
            spread: 100,
            origin: { y: 0.55 },
          });
        }, 300);
      } catch (err) {
        // helpful debug log
        // (if import fails – probably not installed or bundler issue)
        // eslint-disable-next-line no-console
        console.error("Confetti failed:", err);
      }
    },
  },
};
</script>

<style scoped>
/* canvas sits absolute above card so confetti overlays content */
.card {
}
.position-relative {
  position: relative;
  background: linear-gradient(90deg, #30b8b8, #103e90) !important;
}

.confetti-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none; /* clicks pass through */
  z-index: 50;
}
</style>
